export default function () {
  if (this.$route.params.id && parseInt(this.$route.params.id) === this.id) {
    this.openOrderModal(this.id)
    this.$route.params.id = null
    this.$router.push(this.$route)
  }
}
